// Utilidades para nombres de profesionales.

// Prefijo de título profesional al comienzo del nombre: uno o más tokens de
// letras seguidos de punto (p. ej. "DR.", "DRA.", "LIC.", "KLGA.", "PROF. DR.").
// En el formato "APELLIDO, NOMBRE" el apellido nunca termina en punto, así que
// cualquier token inicial con punto es un título y se puede quitar sin riesgo.
const TITLE_PREFIX_RE = /^(?:[A-Za-zÁÉÍÓÚÜÑáéíóúüñ]+\.\s*)+/;

/**
 * Quita el título ("DR.", "DRA.", "LIC.", …) del comienzo del nombre de un
 * profesional.
 *
 * El backend guarda algunos nombres como "DR. APELLIDO, NOMBRE" y la búsqueda
 * por `vTexto` (match tipo "contiene") NO encuentra el registro si se envía con
 * el título adelante. El nombre realmente buscable es "APELLIDO, NOMBRE".
 */
export function stripProfessionalTitle(name: string | undefined | null): string {
  const value = (name ?? '').trim();
  if (!value) return '';
  return value.replace(TITLE_PREFIX_RE, '').trim();
}
